import { render, staticRenderFns } from "./commentsTable.vue?vue&type=template&id=3882105c&scoped=true"
import script from "./commentsTable.vue?vue&type=script&lang=ts"
export * from "./commentsTable.vue?vue&type=script&lang=ts"
import style0 from "./commentsTable.vue?vue&type=style&index=0&id=3882105c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3882105c",
  null
  
)

export default component.exports